module.exports = __webpack_public_path__ + "static/Josh-5c5006dcd49d9e21a5d68cee85f40a59.mp4";